export default __webpack_public_path__ + "static/media/bxs-star_active.ea349ec6.svg";